import { FC, ReactNode } from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cn } from '@fe-learner-common';
export interface TooltipProps extends TooltipPrimitive.TooltipContentProps {
  children: ReactNode;
  text: string;
  container: HTMLElement;
  parentOpen?: boolean;
  disabled?: boolean;
  contentClassName?: string;
}

export const Tooltip: FC<TooltipProps> = ({
  children,
  text,
  side,
  parentOpen,
  container,
  disabled,
  contentClassName,
}) => {
  if (disabled) {
    return children;
  }
  return (
    <TooltipPrimitive.Provider delayDuration={300}>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger
          {...(parentOpen ? { 'data-state': 'open' } : {})}
          asChild
        >
          {children}
        </TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal container={container}>
          <TooltipPrimitive.Content
            id="radix-tooltip"
            className={cn(
              'lf:rounded-lg lf:bg-neutral-900 lf:px-3 lf:py-2',
              contentClassName,
            )}
            side={side}
            sideOffset={5}
          >
            <p className="lf:text-body-sm lf:text-neutral-0">{text}</p>
            <TooltipPrimitive.Arrow className="lf:fill-neutral-900" />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
};
